import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "telegram-plane-brands",
  "use": "telegram-plane-brands-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"telegram-plane-brands\"><path d=\"M23.932 3.769l-3.622 17.08c-.273 1.205-.986 1.505-1.998.937l-5.519-4.066-2.663 2.56c-.294.296-.54.542-1.109.542l.397-5.62L19.645 5.96c.445-.397-.096-.616-.69-.22L6.31 13.702.867 11.998c-1.184-.37-1.205-1.184.247-1.752l21.29-8.203c.986-.37 1.85.22 1.528 1.726z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol